import { Component, OnDestroy, OnInit } from '@angular/core';
import { Register } from '@assetaccountant/core/models/register';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-start-banner',
  templateUrl: './start-banner.component.html',
  styleUrls: ['./start-banner.component.scss'],
  standalone: false,
})
export class StartBannerComponent implements OnInit, OnDestroy {
  registers: Register[];

  getRegisters$ = this.organisationService
    .listRegisters()
    .pipe(take(1))
    .pipe(tap(({ registers }) => (this.registers = registers)));

  private subscriptions: Subscription[] = [];

  constructor(private organisationService: OrganisationService) {}

  ngOnInit() {
    this.subscriptions.push(this.getRegisters$.subscribe());
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
